import { createApp } from 'vue'
import StafetActions from './StafetActions'

const el = '.kb-component--stafet-flow-actions'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetActionsDOM) => {
            const component = createApp(StafetActions).use(Store)
            component.mount(StafetActionsDOM)
        })
    }
}
